export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
        role: ['admin','encoder','viewer'],
    },
    {
        id: 2,
        label: "Dashboard",
        icon: "bx-home-circle",
        link: "/dashboard",
        role: ['admin','encoder','viewer'],
    },
    {
        id: 2,
        label: "Search Entries",
        icon: "bx-search",
        link: "/search",
        role: ['admin','encoder','viewer'],
    },
    {
        id: 2,
        label: "User Management",
        icon: "bx-user-plus",
        link: "/user",
        role: ['admin'],
    },
    {
        id: 2,
        label: "Seasons",
        icon: "bx-calendar",
        link: "/seasons",
        role: ['admin','encoder','viewer'],
    },
    {
        id: 2,
        label: "Summary",
        icon: "bx-file",
        link: "/summary",
        role: ['admin'],
    },
    {
        id: 2,
        label: "Archive",
        icon: "bx-archive",
        link: "/archive",
        role: ['admin', 'encoder', 'viewer'],
    },
    {
        id: 2,
        label: "Security",
        icon: "bx-shield",
        link: "/security",
        role: ['admin','encoder','viewer'],
    },
    {
        id: 2,
        label: "Activity Logs",
        icon: "bx-search-alt-2",
        link: "/activity-logs",
        role: ['admin'],
    },
    {
        id: 2,
        label: "Admin Settings",
        icon: "bx-cog",
        role: ['admin'],
        subItems: [
            {
                label: "Season Color Management",
                link: "/admin-settings/season-colors",
            },
        ],
    },
    {
        id: 2,
        label: "Mobile Dashboard",
        icon: "bx-mobile-alt",
        link: "/mobile-dashboard",
        role: ['admin', 'encoder'],
    },
];